export const ICON_SIZE = 54;
export const PROMOTION_MODAL_WIDTH = 876;
export const PROMOTION_MODAL_PARAM_KEY = 'promotion_id';

